module.exports = __webpack_public_path__ + "img/merlocode-textonly.231cfd42.png";